export default "__VITE_PUBLIC_ASSET__b84ea10e__"